import {VIEW_TYPES} from "./OtherKeys.jsx";

export const SWIVU_STANDARD_ICONS = {
  [VIEW_TYPES.resources]: "fa-light fa-screwdriver-wrench",
  [VIEW_TYPES.tasks]: "fa-light fa-swap-arrows",
  [VIEW_TYPES.clients]: "fa-light fa-building-user",
  [VIEW_TYPES.users]: "fa-light fa-users",
  [VIEW_TYPES.schedulerView]: "fa-light fa-calendar-days",
  [VIEW_TYPES.planView]: "fa-light fa-diagram-predecessor",
  [VIEW_TYPES.checklists]: "fa-light fa-list-check",
  [VIEW_TYPES.notify]: "fa-light fa-bullhorn",
  [VIEW_TYPES.contacts]: "fa-light fa-address-card",
  [VIEW_TYPES.taskBudget]: "fa-light fa-coins",
  [VIEW_TYPES.reminder]: "fa-light fa-alarm-clock",
  [VIEW_TYPES.incentivePoints]: "fa-light fa-award",
  [VIEW_TYPES.coverage]: "fa-light fa-chart-tree-map",
  addUser: "fa-light fa-user-plus",
  defaultView: "fa-light fa-layer-group",
}
